import { combineReducers } from "@reduxjs/toolkit";
import trsStatements from "./trs-statements";

const trsStatementsReducer = combineReducers({
  trsStatements,
});

export default trsStatementsReducer;
